import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ApprovalRequest } from 'icreate/common/models/approval-request';
import { Graph } from 'icreate/common/models/graphs';
import { Mimic } from 'icreate/common/models/mimic';
import { Vessel } from 'icreate/common/models/vessel';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PullProjectService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async pullMimics(iAPIShipyardlId, iAPIVesselId, version): Promise<Mimic[]> {
        const blobParameters = {
            iAPIVesselId,
            iAPIShipyardlId,
            version,
        };
        return await lastValueFrom(
            this.http.get<Mimic[]>(`${this.domain}/api/pull/mimics`, { params: blobParameters })
        );
    }

    async pullGraphs(iAPIShipyardlId, iAPIVesselId, version): Promise<Graph[]> {
        const blobParameters = {
            iAPIVesselId,
            iAPIShipyardlId,
            version,
        };
        return await lastValueFrom(
            this.http.get<Graph[]>(`${this.domain}/api/pull/graphs`, { params: blobParameters })
        );
    }

    async pullVesselByVersion(iAPIShipyardlId: string, iAPIVesselId: string, version: string): Promise<Vessel> {
        const blobParameters = {
            iAPIVesselId,
            iAPIShipyardlId,
            version,
        };
        return await lastValueFrom(this.http.get<Vessel>(`${this.domain}/api/pull/vessel`, { params: blobParameters }));
    }

    async getPublishReason(vesseliApi, shipyardiApi, version): Promise<ApprovalRequest> {
        const blobParameters = {
            vesseliApi,
            shipyardiApi,
            version,
        };
        return await lastValueFrom(
            this.http.get<ApprovalRequest>(`${this.domain}/api/pull/publishReason`, {
                params: blobParameters,
            })
        );
    }
}
